import { get, useFormContext } from "react-hook-form";

import FormField from "ds/components/Form/Field";
import Textarea from "ds/components/Textarea";

type FormDescriptionFieldProps = {
  name: string;
  minRows?: number;
  noMargin?: boolean;
};

const FormDescriptionField = ({ name, minRows = 1, noMargin }: FormDescriptionFieldProps) => {
  const { register, formState } = useFormContext();
  const error = get(formState.errors, name);

  return (
    <FormField label="Description" fullWidth isOptional error={error?.message} noMargin={noMargin}>
      {({ ariaInputProps }) => (
        <Textarea
          minRows={minRows}
          maxRows={15}
          placeholder="Enter description here..."
          error={!!error}
          {...register(name)}
          {...ariaInputProps}
        />
      )}
    </FormField>
  );
};

export default FormDescriptionField;
